import React, { useState, useCallback, useEffect, useRef } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import ReactFlow, {
  addEdge,
  MiniMap,
  Controls,
  Background,
  Handle,
  Position,
  useStoreState,
} from "react-flow-renderer";
import {
  Button,
  Paper,
  Typography,
  makeStyles,
  useTheme,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
  Drawer,
  IconButton,
  Box,
  Avatar,
  Chip,
  FormControlLabel,
  Switch,
  Menu,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  ListItemText
} from "@material-ui/core";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import AddPhotoAlternateOutlinedIcon from "@material-ui/icons/AddPhotoAlternateOutlined";
import TuneRoundedIcon from "@material-ui/icons/TuneRounded";
import RoomRoundedIcon from "@material-ui/icons/RoomRounded";
import EditorDeImagem from "../../components/EditorDeImagem";
import CloseIcon from "@material-ui/icons/Close";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import SendIcon from "@material-ui/icons/Send";
import AddIcon from "@material-ui/icons/Add";
import UndoIcon from "@material-ui/icons/Undo";
import RedoIcon from "@material-ui/icons/Redo";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import WarningIcon from "@material-ui/icons/Warning";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import ChatBubbleOutlineRoundedIcon from "@material-ui/icons/ChatBubbleOutlineRounded";
import ListAltRoundedIcon from "@material-ui/icons/ListAltRounded";
import PersonPinRoundedIcon from "@material-ui/icons/PersonPinRounded";
import TimerRoundedIcon from "@material-ui/icons/TimerRounded";
import MemoryRoundedIcon from "@material-ui/icons/MemoryRounded";
import HeadsetMicRoundedIcon from "@material-ui/icons/HeadsetMicRounded";
import PlayCircleFilledRoundedIcon from "@material-ui/icons/PlayCircleFilledRounded";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import DragIndicatorRoundedIcon from "@material-ui/icons/DragIndicatorRounded";
import TouchAppRoundedIcon from "@material-ui/icons/TouchAppRounded";
import api from "../../services/api";
import openSocket from "../../services/socket-io";
import SeletorConexoes from "../../components/SeletorConexoes";
import { toast } from "react-toastify";
import { poderDeAdmin } from "../../utils/perfil";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 64px)",
    width: "100%"
  },
  content: {
    display: "flex",
    flex: 1,
    overflow: "hidden"
  },
  topBar: {
    // minHeight e nao height: com varias conexoes os chips quebravam linha e
    // vazavam para fora da barra, por cima do quadro.
    minHeight: 64,
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: "flex",
    alignItems: "center",
    padding: "10px 20px",
    backgroundColor: theme.palette.background.paper,
    backgroundImage: theme.palette.type === "dark"
      ? "linear-gradient(90deg, rgba(20,184,166,0.08), transparent 60%)"
      : "linear-gradient(90deg, rgba(13,148,136,0.06), transparent 60%)",
    gap: 14,
    zIndex: 10,
    flexShrink: 0,
  },
  campoTopo: {
    "& .MuiOutlinedInput-root": { borderRadius: 10 },
    "& .MuiSelect-select": { paddingTop: 9, paddingBottom: 9 },
  },
  chipsConexao: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    // uma linha só, com reticências: a barra tem altura fixa e a lista de
    // conexões pode crescer sem limite.
    flexWrap: "nowrap",
    overflow: "hidden",
  },
  botaoTopo: {
    borderRadius: 10,
    textTransform: "none",
    fontWeight: 600,
    padding: "7px 16px",
    whiteSpace: "nowrap",
    boxShadow: "none",
    "&:hover": { boxShadow: "none" },
  },
  divisorTopo: {
    width: 1,
    alignSelf: "stretch",
    backgroundColor: theme.palette.divider,
    margin: "0 2px",
  },
  simulatorDrawer: {
    width: 350,
    padding: 20,
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.type === "dark" ? "#13201f" : "#e6f2ea"
  },
  chatMessageContainer: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflowY: "auto",
    padding: 10,
    gap: 10
  },
  chatBubbleBot: {
    backgroundColor: theme.palette.type === "dark" ? "#1e293b" : "#fff",
    color: theme.palette.text.primary,
    padding: 10,
    borderRadius: "4px 14px 14px 14px",
    maxWidth: "85%",
    boxShadow: "0 2px 6px rgba(10,38,36,0.10)",
    fontSize: "0.9rem",
    animation: "iaSubir .25s ease backwards",
  },
  chatBubbleUser: {
    backgroundColor: theme.palette.type === "dark" ? "#11643c" : "#d4f6dc",
    color: theme.palette.text.primary,
    padding: 10,
    borderRadius: "14px 4px 14px 14px",
    alignSelf: "flex-end",
    maxWidth: "85%",
    boxShadow: "0 2px 6px rgba(13,148,136,0.12)",
    fontSize: "0.9rem",
    animation: "iaSubir .25s ease backwards",
  },
  chatBubbleSystem: {
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)",
    padding: "5px 12px",
    borderRadius: "15px",
    alignSelf: "center",
    fontSize: "0.75rem",
    color: theme.palette.type === "dark" ? "#aaa" : "#555",
    margin: "10px 0"
  },

  
  sidebar: {
    width: "clamp(230px, 22vw, 290px)",
    flexShrink: 0,
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    gap: 10,
    borderRight: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.type === "dark" ? "#0e1716" : "#f8fafc",
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "clamp(200px, 42vw, 250px)"
    }
  },
  paletaTopo: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  paletaTitulo: { fontSize: "1.05rem", fontWeight: 800, color: theme.palette.text.primary },
  paletaSub: { fontSize: "0.75rem", color: theme.palette.text.secondary, marginTop: 2 },
  dica: {
    display: "flex",
    gap: 8,
    alignItems: "flex-start",
    marginTop: 6,
    padding: "10px 12px",
    borderRadius: 12,
    fontSize: "0.72rem",
    lineHeight: 1.45,
    color: theme.palette.text.secondary,
    background: theme.palette.type === "dark" ? "rgba(20,184,166,0.07)" : "rgba(20,184,166,0.06)",
    border: `1px dashed ${theme.palette.type === "dark" ? "rgba(20,184,166,0.25)" : "rgba(20,184,166,0.30)"}`,
  },
  botaoSalvar: {
    borderRadius: 12,
    textTransform: "none",
    fontWeight: 700,
    padding: "10px 16px",
  },
  modalBloco: {
    borderRadius: 18,
    overflow: "hidden",
    animation: "iaModalEntrar .3s cubic-bezier(.22,1,.36,1)",
    backgroundColor: theme.palette.type === "dark" ? "#121c1b" : "#ffffff",
  },
  modalCabecalho: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "16px 18px",
    color: "#ffffff",
  },
  modalIcone: {
    width: 42,
    height: 42,
    borderRadius: 12,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.22)",
    border: "1px solid rgba(255,255,255,0.35)",
    flexShrink: 0,
  },
  modalTitulo: { fontSize: "1.05rem", fontWeight: 800, lineHeight: 1.2 },
  modalSub: { fontSize: "0.8rem", opacity: 0.9, marginTop: 2 },
  imgAdicionar: {
    marginTop: 10,
    padding: "14px 0",
    borderRadius: 12,
    borderStyle: "dashed",
    textTransform: "none",
    fontWeight: 700,
    color: "#0d9488",
    borderColor: "rgba(13,148,136,.5)",
  },
  imgBloco: {
    marginTop: 10,
    display: "flex",
    gap: 12,
    alignItems: "center",
    padding: 10,
    borderRadius: 12,
    border: `1px solid ${theme.palette.divider}`,
  },
  imgPrevia: {
    width: 96,
    height: 96,
    objectFit: "contain",
    backgroundColor: "rgba(13,148,136,.06)",
    borderRadius: 10,
    flexShrink: 0,
  },
  imgAcoes: { display: "flex", flexDirection: "column", gap: 6, alignItems: "flex-start" },
  imgMedida: { fontSize: 11, color: theme.palette.text.secondary },
  zapCaixa: {
    marginTop: 14,
    borderRadius: 12,
    overflow: "hidden",
    border: `1px solid ${theme.palette.divider}`,
  },
  zapTopo: {
    padding: "8px 12px",
    fontSize: 12,
    fontWeight: 800,
    color: "#fff",
    backgroundColor: "#0f766e",
  },
  zapFundo: {
    padding: 12,
    backgroundColor: theme.palette.type === "dark" ? "#0b1f1d" : "#ece5dd",
    display: "flex",
  },
  zapBalao: {
    marginLeft: "auto",
    maxWidth: 300,
    padding: 4,
    borderRadius: 10,
    backgroundColor: theme.palette.type === "dark" ? "#134e4a" : "#d9fdd3",
    boxShadow: "0 1px 1px rgba(0,0,0,.1)",
    display: "flex",
    flexDirection: "column",
  },
  zapImagem: {
    display: "block",
    width: "100%",
    maxHeight: 420,
    objectFit: "contain",
    borderRadius: 8,
    backgroundColor: "rgba(0,0,0,.04)",
  },
  zapTexto: {
    padding: "6px 6px 0",
    fontSize: 13.5,
    lineHeight: 1.4,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    color: theme.palette.text.primary,
  },
  zapHora: { alignSelf: "flex-end", fontSize: 10.5, color: theme.palette.text.secondary, padding: "2px 6px 2px" },
  zapAviso: {
    padding: "8px 12px",
    fontSize: 12,
    lineHeight: 1.45,
    color: "#92400e",
    backgroundColor: "#fffbeb",
    borderTop: "1px solid #fde68a",
  },
  modalCorpo: {
    padding: "20px 22px 8px !important",
    "& .MuiOutlinedInput-root": { borderRadius: 12 },
    "& .MuiTypography-subtitle2": { display: "none" },
    "& .MuiFormHelperText-root": { marginTop: 6, lineHeight: 1.4 },
  },
  modalRodape: {
    padding: "12px 18px 16px",
    gap: 8,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  blocksCollapsed: {
    width: 34,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    paddingTop: 8,
    borderRight: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  flowWrapper: {
    flex: 1,
    position: "relative",
    height: "100%",
    // quadro com leve brilho verde nos cantos
    background: theme.palette.type === "dark"
      ? "radial-gradient(600px 300px at 0% 100%, rgba(20,184,166,0.08), transparent 70%), #0e1626"
      : "radial-gradient(600px 300px at 0% 100%, rgba(13,148,136,0.06), transparent 70%), #fbfdfc",
  },
  // blocos da paleta: cartao com icone colorido, nome e explicacao
  nodeItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 10px 10px 12px",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(148,163,184,0.14)" : "#e5e9f0"}`,
    borderRadius: 14,
    cursor: "grab",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.palette.type === "dark" ? "none" : "0 2px 6px rgba(15,23,42,0.04)",
    transition: "transform .2s ease, box-shadow .2s ease, border-color .2s ease",
    animation: "iaSubir .35s ease backwards",
    "&:hover": {
      transform: "translateY(-2px)",
      borderColor: "var(--cor)",
      boxShadow: theme.palette.type === "dark"
        ? "0 10px 22px rgba(0,0,0,0.45)"
        : "0 10px 20px rgba(15,23,42,0.08)",
      "& $nodeItemIcone": { transform: "rotate(-8deg) scale(1.08)" },
      "& $nodeItemArrastar": { opacity: 1 },
    },
    "&:active": { cursor: "grabbing", transform: "scale(.98)" },
  },
  nodeItemIcone: {
    width: 38,
    height: 38,
    borderRadius: 11,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--cor)",
    background: "var(--cor-suave)",
    flexShrink: 0,
    transition: "transform .25s ease",
  },
  nodeItemNome: {
    display: "block",
    fontSize: "0.84rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  nodeItemDesc: {
    display: "block",
    fontSize: "0.7rem",
    color: theme.palette.text.secondary,
    marginTop: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  nodeItemArrastar: {
    color: theme.palette.text.secondary,
    opacity: 0.35,
    fontSize: 18,
    transition: "opacity .2s ease",
  },
  customNode: {
    padding: 10,
    borderRadius: 5,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
    minWidth: 150,
  },
  nodeHeader: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 5,
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: 5
  }
}));

// Cada tipo de bloco: nome, explicacao curta, cor e icone. A paleta, os nos
// do quadro e o modal de edicao usam a mesma tabela.
const BLOCOS = {
  startNode: { nome: "Início do Bot", desc: "Onde a conversa começa", cor: "#0d9488", Icone: PlayCircleFilledRoundedIcon },
  textNode: { nome: "Mensagem de Texto", curto: "Texto", desc: "Envia uma mensagem ao candidato", cor: "#14b8a6", Icone: ChatBubbleOutlineRoundedIcon },
  menuNode: { nome: "Menu de Opções", curto: "Menu (Opções)", desc: "Pergunta com opções numeradas", cor: "#0ea5e9", Icone: ListAltRoundedIcon },
  queueNode: { nome: "Transferir para Usuário", curto: "Transferir para Usuário", desc: "Manda direto para um atendente", cor: "#f59e0b", Icone: PersonPinRoundedIcon },
  delayNode: { nome: "Tempo de Espera", curto: "Tempo de Espera", desc: "Pausa antes do próximo passo", cor: "#06b6d4", Icone: TimerRoundedIcon },
  locationNode: { nome: "Localização", curto: "Localização", desc: "Manda o mapa da empresa", cor: "#ef4444", Icone: RoomRoundedIcon },
  aiNode: { nome: "Enviar para IA", curto: "Enviar para IA", desc: "A assistente assume daqui", cor: "#a855f7", Icone: MemoryRoundedIcon },
  humanNode: { nome: "Enviar para humano", curto: "Enviar para humano", desc: "Fila de atendimento humano", cor: "#3b82f6", Icone: HeadsetMicRoundedIcon },
};
const ORDEM_PALETA = ["textNode", "menuNode", "locationNode", "queueNode", "delayNode", "aiNode", "humanNode"];

const NOME_DO_BLOCO = Object.fromEntries(Object.entries(BLOCOS).map(([k, v]) => [k, v.nome]));

const nomeDoBloco = (node) =>
  (node && NOME_DO_BLOCO[node.type]) || "Bloco";

const hexRgba = (hex, a) => {
  const h = String(hex || "#14b8a6").replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map(c => c + c).join("") : h, 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

export const HandleMenuContext = React.createContext();

// Bolinha de conexao: verde quando livre, cinza quando ja ligada.
const estiloPonto = (ocupado, extra = {}) => ({
  width: 11,
  height: 11,
  background: ocupado ? "#94a3b8" : "#14b8a6",
  border: "2px solid #ffffff",
  boxShadow: "0 0 0 2px rgba(20,184,166,.25)",
  cursor: ocupado ? "default" : "crosshair",
  ...extra,
});

// Cartao padrao dos blocos no quadro: cabecalho colorido com icone + corpo.
const CartaoNo = ({ tipo, selected, children, larguraMin = 190 }) => {
  const theme = useTheme();
  const escuro = theme.palette.type === "dark";
  const meta = BLOCOS[tipo];
  const Icone = meta.Icone;
  return (
    <div
      style={{
        minWidth: larguraMin,
        maxWidth: 260,
        borderRadius: 14,
        overflow: "visible",
        background: escuro ? "#121c1b" : "#ffffff",
        border: `1.5px solid ${selected ? meta.cor : escuro ? "rgba(148,163,184,.18)" : "#e5e9f0"}`,
        boxShadow: selected
          ? `0 0 0 4px ${hexRgba(meta.cor, 0.18)}, 0 12px 28px rgba(15,23,42,.18)`
          : escuro ? "0 8px 22px rgba(0,0,0,.45)" : "0 6px 18px rgba(15,23,42,.08)",
        transition: "box-shadow .2s ease, border-color .2s ease",
        fontFamily: "inherit",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "8px 12px",
          borderRadius: "12px 12px 0 0",
          background: `linear-gradient(135deg, ${hexRgba(meta.cor, escuro ? 0.28 : 0.16)}, ${hexRgba(meta.cor, escuro ? 0.10 : 0.05)})`,
          borderBottom: `1px solid ${hexRgba(meta.cor, 0.22)}`,
        }}
      >
        <span
          style={{
            width: 24, height: 24, borderRadius: 8, display: "inline-flex", alignItems: "center",
            justifyContent: "center", background: meta.cor, color: "#fff", flexShrink: 0,
            boxShadow: `0 4px 10px ${hexRgba(meta.cor, 0.4)}`,
          }}
        >
          <Icone style={{ fontSize: 15 }} />
        </span>
        <span style={{ fontSize: 12.5, fontWeight: 800, color: escuro ? "#f1f5f9" : "#121c1b", whiteSpace: "nowrap" }}>
          {meta.nome}
        </span>
      </div>
      {children ? (
        <div style={{ padding: "8px 12px 10px", fontSize: 11.5, color: escuro ? "#94a3b8" : "#475569", lineHeight: 1.45 }}>
          {children}
        </div>
      ) : null}
    </div>
  );
};

const resumo = (txt, n = 70) => {
  const t = String(txt || "").trim();
  return t.length > n ? `${t.slice(0, n)}…` : t;
};

const StartNode = ({ id, data }) => {
  const edges = useStoreState((st) => st.edges);
  const ocupado = edges.some((ed) => ed.source === id && !ed.sourceHandle);
  return (
    <div style={{ position: "relative" }}>
      <div
        style={{
          display: "flex", alignItems: "center", gap: 8, padding: "10px 16px", borderRadius: 30,
          background: "linear-gradient(135deg, #0d9488, #14b8a6)", color: "#fff", fontWeight: 800,
          fontSize: 13, boxShadow: "0 10px 24px rgba(20,184,166,.35)",
        }}
      >
        <PlayCircleFilledRoundedIcon style={{ fontSize: 18 }} /> Início do Bot
      </div>
      <Handle type="source" position={Position.Bottom} isConnectable={!ocupado} style={estiloPonto(ocupado, { bottom: -6 })} />
    </div>
  );
};

const TextNode = ({ id, data, selected }) => {
  const edges = useStoreState((st) => st.edges);
  const entrada = edges.some((ed) => ed.target === id);
  const ocupado = edges.some((ed) => ed.source === id && !ed.sourceHandle);
  return (
    <div style={{ position: "relative" }}>
      <Handle type="target" position={Position.Top} style={estiloPonto(entrada, { top: -6 })} />
      <CartaoNo tipo="textNode" selected={selected}>
        {data.imagemUrl ? (
          <img
            src={data.imagemUrl}
            alt=""
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
            style={{ pointerEvents: "none", userSelect: "none", display: "block", width: "100%", maxHeight: 150, objectFit: "contain", background: "rgba(13,148,136,.06)", borderRadius: 8, marginBottom: 6 }}
          />
        ) : null}
        {data.text ? resumo(data.text) : data.imagemUrl ? <i>Imagem sem legenda</i> : <i>Clique para escrever a mensagem</i>}
        {data.waitForReply ? (
          <div style={{ marginTop: 6, fontSize: 10.5, fontWeight: 700, color: "#0d9488" }}>⏳ Aguarda resposta</div>
        ) : null}
      </CartaoNo>
      <Handle type="source" position={Position.Bottom} isConnectable={!ocupado} style={estiloPonto(ocupado, { bottom: -6 })} />
    </div>
  );
};

const MenuNode = ({ id, data, selected }) => {
  const theme = useTheme();
  const escuro = theme.palette.type === "dark";
  const edges = useStoreState((st) => st.edges);
  const entrada = edges.some((ed) => ed.target === id);
  const options = data.options || [];
  return (
    <div style={{ position: "relative" }}>
      <Handle type="target" position={Position.Top} style={estiloPonto(entrada, { top: -6 })} />
      <CartaoNo tipo="menuNode" selected={selected} larguraMin={220}>
        {data.text ? <div style={{ whiteSpace: "pre-wrap", marginBottom: 6 }}>{resumo(data.text, 90)}</div> : null}
        {options.map((opt, index) => {
          const ocupado = edges.some((ed) => ed.source === id && ed.sourceHandle === `option_${index}`);
          return (
            <div
              key={index}
              style={{
                position: "relative", margin: "5px -4px 0", padding: "6px 14px 6px 10px", borderRadius: 8,
                fontSize: 11.5, fontWeight: 600, color: escuro ? "#e2e8f0" : "#121c1b",
                background: escuro ? "rgba(14,165,233,.10)" : "rgba(14,165,233,.07)",
                border: `1px solid ${escuro ? "rgba(14,165,233,.22)" : "rgba(14,165,233,.18)"}`,
              }}
            >
              {opt}
              <Handle
                type="source"
                position={Position.Right}
                id={`option_${index}`}
                isConnectable={!ocupado}
                style={estiloPonto(ocupado, { top: "50%", right: -17 })}
              />
            </div>
          );
        })}
        {options.length === 0 && <i>Nenhuma opção ainda</i>}
      </CartaoNo>
    </div>
  );
};

const AINode = ({ id, data, selected }) => {
  const edges = useStoreState((st) => st.edges);
  const entrada = edges.some((ed) => ed.target === id);
  return (
    <div style={{ position: "relative" }}>
      <Handle type="target" position={Position.Top} style={estiloPonto(entrada, { top: -6 })} />
      <CartaoNo tipo="aiNode" selected={selected}>
        <b>Assistente de RH</b>
        {data.instrucao ? <div style={{ marginTop: 4 }}>{resumo(data.instrucao, 60)}</div> : null}
      </CartaoNo>
    </div>
  );
};

const QueueNode = ({ id, data, selected }) => {
  const edges = useStoreState((st) => st.edges);
  const entrada = edges.some((ed) => ed.target === id);
  return (
    <div style={{ position: "relative" }}>
      <Handle type="target" position={Position.Top} style={estiloPonto(entrada, { top: -6 })} />
      <CartaoNo tipo="queueNode" selected={selected}>
        {data.userName ? <b>{data.userName}</b> : <i>Escolha o atendente</i>}
      </CartaoNo>
    </div>
  );
};

const HumanNode = ({ id, data, selected }) => {
  const edges = useStoreState((st) => st.edges);
  const entrada = edges.some((ed) => ed.target === id);
  return (
    <div style={{ position: "relative" }}>
      <Handle type="target" position={Position.Top} style={estiloPonto(entrada, { top: -6 })} />
      <CartaoNo tipo="humanNode" selected={selected}>
        {data.userName ? <b>{data.userName}</b> : "Qualquer atendente"}
      </CartaoNo>
    </div>
  );
};

const DelayNode = ({ id, data, selected }) => {
  const edges = useStoreState((st) => st.edges);
  const entrada = edges.some((ed) => ed.target === id);
  const ocupado = edges.some((ed) => ed.source === id && !ed.sourceHandle);
  return (
    <div style={{ position: "relative" }}>
      <Handle type="target" position={Position.Top} style={estiloPonto(entrada, { top: -6 })} />
      <CartaoNo tipo="delayNode" selected={selected}>
        Aguarda <b>{data.delay || 0} segundos</b>
      </CartaoNo>
      <Handle type="source" position={Position.Bottom} isConnectable={!ocupado} style={estiloPonto(ocupado, { bottom: -6 })} />
    </div>
  );
};

const LocationNode = ({ id, selected }) => {
  const edges = useStoreState((st) => st.edges);
  const entrada = edges.some((ed) => ed.target === id);
  const ocupado = edges.some((ed) => ed.source === id && !ed.sourceHandle);
  return (
    <div style={{ position: "relative" }}>
      <Handle type="target" position={Position.Top} style={estiloPonto(entrada, { top: -6 })} />
      <CartaoNo tipo="locationNode" selected={selected}>
        📍 Pino no mapa + link do Google Maps
      </CartaoNo>
      <Handle type="source" position={Position.Bottom} isConnectable={!ocupado} style={estiloPonto(ocupado, { bottom: -6 })} />
    </div>
  );
};

const nodeTypes = {
  locationNode: LocationNode,
  startNode: StartNode,
  textNode: TextNode,
  menuNode: MenuNode,
  aiNode: AINode,
  queueNode: QueueNode,
  humanNode: HumanNode,
  delayNode: DelayNode
};

let idCounter = 0;
const getId = () => `node_${idCounter++}`;

const ChatbotBuilder = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const simStartedRef = useRef(false);
  const selectedElementsRef = useRef([]);
  const reactFlowWrapper = useRef(null);

  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [blocksOpen, setBlocksOpen] = useState(true);
  const [chatbot, setChatbot] = useState(null);
  const saveTimeoutRef = useRef(null);

  const [selectedNode, setSelectedNode] = useState(null);

  const [atendentes, setAtendentes] = useState([]);

  const [whatsapps, setWhatsapps] = useState([]);
  const [chatbots, setChatbots] = useState([]);
  const [selectedWhatsapps, setSelectedWhatsapps] = useState([]);
  const [simulatorOpen, setSimulatorOpen] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [currentNodeId, setCurrentNodeId] = useState("start");
  const [simulatorInputText, setSimulatorInputText] = useState("");
  const [handleMenu, setHandleMenu] = useState({ open: false, anchorEl: null, anchorPosition: null, sourceNodeId: null, sourceHandleId: null });
  const connectingRef = useRef(null);
  const connectionMadeRef = useRef(false);

  const [newChatbotModalOpen, setNewChatbotModalOpen] = useState(false);
  const [newChatbotName, setNewChatbotName] = useState("");
  const [saveStatus, setSaveStatus] = useState("idle");
  const [validationDialogOpen, setValidationDialogOpen] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  const undoStackRef = useRef([]);
  const redoStackRef = useRef([]);
  const nodesRef = useRef(nodes);
  const edgesRef = useRef(edges);
  nodesRef.current = nodes;
  edgesRef.current = edges;
  // zoom/posicao da tela (salvos junto com o fluxo)
  const viewportRef = useRef(null);
  const viewportAplicadoRef = useRef(false);
  const salvarPendenteRef = useRef(false);
  const idAtualRef = useRef(id);
  idAtualRef.current = id;
  const MAX_UNDO = 30;

  const pushToUndoStack = () => {
    const snapshot = {
      nodes: JSON.parse(JSON.stringify(nodesRef.current)),
      edges: JSON.parse(JSON.stringify(edgesRef.current))
    };
    undoStackRef.current = [...undoStackRef.current.slice(-MAX_UNDO + 1), snapshot];
    redoStackRef.current = [];
  };

  const handleUndo = () => {
    if (undoStackRef.current.length === 0) return;
    const currentSnapshot = {
      nodes: JSON.parse(JSON.stringify(nodesRef.current)),
      edges: JSON.parse(JSON.stringify(edgesRef.current))
    };
    redoStackRef.current = [...redoStackRef.current, currentSnapshot];
    const prev = undoStackRef.current[undoStackRef.current.length - 1];
    undoStackRef.current = undoStackRef.current.slice(0, -1);
    setNodes(prev.nodes);
    setEdges(prev.edges);
    setSelectedNode(null);
    triggerAutoSave();
  };

  const handleRedo = () => {
    if (redoStackRef.current.length === 0) return;
    const currentSnapshot = {
      nodes: JSON.parse(JSON.stringify(nodesRef.current)),
      edges: JSON.parse(JSON.stringify(edgesRef.current))
    };
    undoStackRef.current = [...undoStackRef.current, currentSnapshot];
    const next = redoStackRef.current[redoStackRef.current.length - 1];
    redoStackRef.current = redoStackRef.current.slice(0, -1);
    setNodes(next.nodes);
    setEdges(next.edges);
    setSelectedNode(null);
    triggerAutoSave();
  };

  const handleDuplicateNode = () => {
    if (!selectedNode || selectedNode.id === "start") return;
    pushToUndoStack();
    const newId = getId();
    const newNode = {
      ...selectedNode,
      id: newId,
      position: {
        x: selectedNode.position.x + 50,
        y: selectedNode.position.y + 80
      },
      data: JSON.parse(JSON.stringify(selectedNode.data))
    };
    setNodes(nds => nds.concat(newNode));
    triggerAutoSave();
    toast.success("Nó duplicado!");
  };

  const validateFlow = () => {
    const errors = [];
    const startNode = nodes.find(n => n.id === "start" || n.type === "startNode");
    if (!startNode) {
      errors.push({ type: "error", text: "Nó de Início não encontrado." });
    }
    
    const connectedTargets = new Set(edges.map(e => e.target));
    
    nodes.forEach(n => {
      if (n.id === "start" || n.type === "startNode") return;
      if (!connectedTargets.has(n.id)) {
        const typeName = n.type === "textNode" ? "Mensagem de Texto" : n.type === "menuNode" ? "Menu" : n.type === "queueNode" ? "Transferir para Usuário" : n.type === "delayNode" ? "Espera" : n.type === "locationNode" ? "Localização" : n.type === "aiNode" ? "Enviar para IA" : n.type === "humanNode" ? "Enviar para humano" : n.type;
        let idText = "";
        if ((n.type === "textNode" || n.type === "menuNode") && n.data.text) {
          idText = ` ("${n.data.text.substring(0, 20)}...")`;
        }
        errors.push({ type: "warning", text: `Bloco de ${typeName}${idText} está solto no fluxo (sem conexão de entrada).` });
      }
    });

    nodes.forEach(n => {
      if (n.type === "textNode" && !n.data.imagem && (!n.data.text || !n.data.text.trim())) {
        errors.push({ type: "warning", text: `Um bloco de Mensagem de Texto está vazio (precisa de conteúdo).` });
      }
      if (n.type === "queueNode" && !n.data.userId) {
        errors.push({ type: "warning", text: `Um bloco de Transferir para Usuário não possui um atendente selecionado.` });
      }
      if (n.type === "menuNode") {
        const options = n.data.options || [];
        options.forEach((opt, idx) => {
          if (!opt.trim()) return; 
          const hasEdge = edges.some(e => e.source === n.id && e.sourceHandle === `option_${idx}`);
          if (!hasEdge) {
            let idText = "";
            if (n.data.text) {
              idText = ` (intro: "${n.data.text.substring(0, 15)}...")`;
            }
            errors.push({ type: "warning", text: `No bloco Menu${idText}, a opção "${opt.trim()}" está sem conexão para o próximo passo.` });
          }
        });
      }
    });
    return errors;
  };

  const handleTestWithValidation = () => {
    const errors = validateFlow();
    if (errors.length > 0) {
      setValidationErrors(errors);
      setValidationDialogOpen(true);
    } else {
      startSimulator();
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      const target = e.target;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return;
      if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        handleUndo();
      }
      if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.key === 'Z' && e.shiftKey))) {
        e.preventDefault();
        handleRedo();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [nodes, edges]);

  const openHandleMenu = (e, nodeId, handleId) => {
    e.stopPropagation();
    setHandleMenu({ open: true, anchorEl: e.currentTarget, sourceNodeId: nodeId, sourceHandleId: handleId });
  };
  
  const closeHandleMenu = () => {
    setHandleMenu({ open: false, anchorEl: null, anchorPosition: null, sourceNodeId: null, sourceHandleId: null });
  };

  const saidaOcupada = (nodeId, handleId) =>
    edges.some(
      (e) => e.source === nodeId && (e.sourceHandle || null) === (handleId || null)
    );

  const handleAddNodeFromMenu = (type) => {
    if (!handleMenu.sourceNodeId) return;

    if (saidaOcupada(handleMenu.sourceNodeId, handleMenu.sourceHandleId)) {
      toast.warn("Essa saída já está ligada a um passo.");
      closeHandleMenu();
      return;
    }

    const sourceNode = nodes.find(n => n.id === handleMenu.sourceNodeId);
    if (!sourceNode) return;

    const position = {
      x: sourceNode.position.x + (handleMenu.sourceHandleId ? 250 : 0),
      y: sourceNode.position.y + (handleMenu.sourceHandleId ? 0 : 150)
    };

    const newNodeId = getId();
    const newNode = {
      id: newNodeId,
      type,
      position,
      data: { text: "", options: [] }
    };

    const newEdge = {
      id: `e_${handleMenu.sourceNodeId}-${handleMenu.sourceHandleId || 'bottom'}-${newNodeId}`,
      source: handleMenu.sourceNodeId,
      sourceHandle: handleMenu.sourceHandleId || null,
      target: newNodeId,
      targetHandle: null
    };

    pushToUndoStack();
    setNodes(nds => nds.concat(newNode));
    setEdges((eds) => addEdge(newEdge, eds));
    
    triggerAutoSave();
    closeHandleMenu();
  };

  useEffect(() => {
    fetchChatbot();
    loadAtendentes();
    loadWhatsappsAndChatbots();
  }, [id]);

  const loadWhatsappsAndChatbots = async () => {
    try {
      const [whatsRes, chatRes] = await Promise.all([
        api.get("/whatsapp"),
        api.get("/chatbots")
      ]);
      setWhatsapps(whatsRes.data || []);
      setChatbots(chatRes.data || []);
      
      const activeWhatsapps = (whatsRes.data || []).filter(w => w.chatbotId === parseInt(id)).map(w => w.id);
      setSelectedWhatsapps(activeWhatsapps);
    } catch (err) {
      toast.error("Erro ao carregar lista de chatbots/conexões");
    }
  };

  // Atualiza so a conexao que mudou (o SeletorConexoes ja salvou no servidor).
  const atualizarConexaoLocal = (whatsId, novoChatbotId) => {
    setWhatsapps((lista) =>
      lista.map((w) => (w.id === whatsId ? { ...w, chatbotId: novoChatbotId } : w))
    );
  };

  // Status ao vivo: numero que cai some da lista "no ar" na hora e volta
  // sozinho quando reconecta, sem precisar recarregar a pagina.
  useEffect(() => {
    const socket = openSocket();
    const aoMudarConexao = (data) => {
      if (data.action === "update" && data.whatsapp) {
        setWhatsapps((lista) => {
          const existe = lista.some((w) => w.id === data.whatsapp.id);
          return existe
            ? lista.map((w) => (w.id === data.whatsapp.id ? { ...w, ...data.whatsapp } : w))
            : [data.whatsapp, ...lista];
        });
      }
      if (data.action === "delete") {
        setWhatsapps((lista) => lista.filter((w) => w.id !== data.whatsappId));
      }
    };
    const aoMudarSessao = (data) => {
      if (data.action === "update" && data.session) {
        setWhatsapps((lista) =>
          lista.map((w) => (w.id === data.session.id ? { ...w, status: data.session.status } : w))
        );
      }
    };
    socket.on("whatsapp", aoMudarConexao);
    socket.on("whatsappSession", aoMudarSessao);
    return () => {
      socket.off("whatsapp", aoMudarConexao);
      socket.off("whatsappSession", aoMudarSessao);
    };
  }, []);

  const handleChatbotChange = async (event) => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    await handleSaveFlow(true);
    salvarPendenteRef.current = false;
    history.push(`/fluxos-visuais/${event.target.value}/builder`);
  };

  const triggerAutoSave = () => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    salvarPendenteRef.current = true;
    setSaveStatus("saving");
    saveTimeoutRef.current = setTimeout(() => {
      saveTimeoutRef.current = null;
      handleSaveFlow(true);
    }, 1200);
  };

  // Monta o fluxo a partir do estado (posicoes ja atualizadas no arrastar).
  const fluxoDoEstado = () => ({
    nodes: nodesRef.current,
    edges: edgesRef.current,
    ...(viewportRef.current ? { viewport: viewportRef.current } : {}),
  });

  // Salva na hora o que estiver pendente (sair da tela, trocar de fluxo).
  const salvarPendenteAgora = (idDoFluxo = idAtualRef.current) => {
    if (!salvarPendenteRef.current) return null;
    if (saveTimeoutRef.current) {
      clearTimeout(saveTimeoutRef.current);
      saveTimeoutRef.current = null;
    }
    salvarPendenteRef.current = false;
    return api
      .put(`/chatbots/${idDoFluxo}`, { flowData: JSON.stringify(fluxoDoEstado()) })
      .catch(() => {});
  };

  // Bloco arrastado: grava a posicao nova no estado e salva.
  const aoTerminarDeArrastar = (_e, arrastados) => {
    const lista = Array.isArray(arrastados) ? arrastados : [arrastados];
    const posicoes = new Map(lista.filter(Boolean).map((n) => [n.id, n.position]));
    if (!posicoes.size) return;
    setNodes((nds) =>
      nds.map((n) => (posicoes.has(n.id) ? { ...n, position: { ...posicoes.get(n.id) } } : n))
    );
    triggerAutoSave();
  };

  // Sai da tela (menu lateral, outra rota) sem esperar o autosave: salva ja.
  useEffect(() => {
    const idDesteFluxo = id; // o id muda antes desta limpeza rodar
    return () => {
      salvarPendenteAgora(idDesteFluxo);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Fechar a aba / recarregar com alteracao ainda nao salva: avisa.
  useEffect(() => {
    const aoSair = (e) => {
      if (!salvarPendenteRef.current) return undefined;
      salvarPendenteAgora();
      e.preventDefault();
      e.returnValue = "";
      return "";
    };
    window.addEventListener("beforeunload", aoSair);
    return () => window.removeEventListener("beforeunload", aoSair);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Ao abrir: volta para o zoom/posicao salvos; sem isso, enquadra tudo.
  useEffect(() => {
    if (!reactFlowInstance || !nodes.length || viewportAplicadoRef.current) return;
    viewportAplicadoRef.current = true;
    const v = viewportRef.current;
    setTimeout(() => {
      try {
        if (v && Number.isFinite(v.zoom)) {
          reactFlowInstance.setTransform({ x: v.x, y: v.y, zoom: v.zoom });
        } else {
          reactFlowInstance.fitView({ padding: 0.2 });
        }
      } catch (e) {
        /* ignore */
      }
    }, 50);
  }, [reactFlowInstance, nodes]);

  const handleCreateChatbot = async () => {
    if (!newChatbotName.trim()) {
      toast.error("O nome é obrigatório");
      return;
    }
    try {
      const { data } = await api.post("/chatbots", {
        name: newChatbotName,
        flowData: "{}",
        active: true
      });
      toast.success("Fluxo criado com sucesso!");
      setNewChatbotModalOpen(false);
      setNewChatbotName("");

      if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
      await handleSaveFlow(true);
      history.push(`/fluxos-visuais/${data.id}/builder`);
    } catch (err) {
      toast.error("Erro ao criar fluxo");
    }
  };

  const startSimulator = () => {
    setChatHistory([{ type: "system", text: "Simulação Iniciada" }]);
    setCurrentNodeId("start");
    setSimulatorOpen(true);
    setTimeout(() => {
      traverseFlow("start");
    }, 500);
  };

  useEffect(() => {
    const wantsSim = new URLSearchParams(location.search).get("sim") === "1";
    if (wantsSim && reactFlowInstance && nodes.length > 0 && !simStartedRef.current) {
      simStartedRef.current = true;
      setTimeout(() => startSimulator(), 400);
    }
    
  }, [location.search, reactFlowInstance, nodes]);

  const traverseFlow = (nodeId, optionIndex = null) => {
    if (!reactFlowInstance) return;
    const flowObject = reactFlowInstance.toObject();
    const elements = flowObject.elements || [];
    const currentNodes = elements.filter(e => !e.source);
    const currentEdges = elements.filter(e => e.source);
    
    let nextEdges = currentEdges.filter(e => e.source === nodeId);
    if (optionIndex !== null) {
      nextEdges = nextEdges.filter(e => e.sourceHandle === `option_${optionIndex}`);
    }

    if (nextEdges.length === 0) {
      setChatHistory(prev => [...prev, { type: "system", text: "Fluxo Finalizado (Fim da linha)" }]);
      return;
    }

    const nextNodeId = nextEdges[0].target;
    const nextNode = currentNodes.find(n => n.id === nextNodeId);
    
    if (!nextNode) return;
    
    setCurrentNodeId(nextNodeId);

    if (nextNode.type === "textNode") {
      setChatHistory(prev => [...prev, {
        type: "bot",
        text: `${nextNode.data.imagem ? "🖼️ [imagem]\n" : ""}${nextNode.data.text || (nextNode.data.imagem ? "" : "Vazio")}`
      }]);
      if (nextNode.data.waitForReply) {
        setChatHistory(prev => [...prev, { type: "system", text: "Aguardando resposta do usuário..." }]);
      } else {
        setTimeout(() => traverseFlow(nextNodeId), 1500);
      }
    } else if (nextNode.type === "menuNode") {
      setChatHistory(prev => [...prev, { type: "bot", text: nextNode.data.text || "Menu de Opções", options: nextNode.data.options || [], nodeId: nextNodeId }]);
    } else if (nextNode.type === "locationNode") {
      setChatHistory(prev => [...prev, { type: "bot", text: "📍 [mapa da empresa]\nAbrir no Google Maps: https://maps.google.com/…" }]);
      setTimeout(() => traverseFlow(nextNodeId), 1200);
    } else if (nextNode.type === "delayNode") {
      setChatHistory(prev => [...prev, { type: "system", text: `Aguardando ${nextNode.data.delay || 0} segundos...` }]);
      setTimeout(() => traverseFlow(nextNodeId), (nextNode.data.delay || 0) * 1000);
    } else if (nextNode.type === "queueNode") {
      setChatHistory(prev => [...prev, { type: "system", text: `Transferindo para o atendente: ${nextNode.data.userName || "Desconhecido"}` }]);
    } else if (nextNode.type === "aiNode") {
      setChatHistory(prev => [...prev, { type: "system", text: `Enviando para Inteligência Artificial` }]);
    } else if (nextNode.type === "humanNode") {
      setChatHistory(prev => [...prev, { type: "system", text: nextNode.data.userName
        ? `Aguardando atendimento humano (${nextNode.data.userName})`
        : `Aguardando atendimento humano` }]);
    }
  };

  const handleSimulatorOptionClick = (nodeId, optionIndex, optText) => {
    setChatHistory(prev => [...prev, { type: "user", text: optText }]);
    setTimeout(() => {
      traverseFlow(nodeId, optionIndex);
    }, 500);
  };

  const handleSimulatorTextSend = () => {
    if (!simulatorInputText.trim()) return;
    const text = simulatorInputText;
    setSimulatorInputText("");
    setChatHistory(prev => [...prev, { type: "user", text }]);
    setTimeout(() => {
      traverseFlow(currentNodeId);
    }, 500);
  };

  const loadAtendentes = async () => {
    try {
      const { data } = await api.get("/users/");
      setAtendentes(data.users || []);
    } catch (err) {
      setAtendentes([]);
    }
  };

  const fetchChatbot = async () => {
    try {
      const { data } = await api.get(`/chatbots/${id}`);
      setChatbot(data);
      if (data.flowData) {
        const flow = JSON.parse(data.flowData);
        if (flow) {
          const loadedNodes = flow.nodes || [];

          const hasStart = loadedNodes.some(n => n.type === "startNode");
          if (loadedNodes.length > 0 && !hasStart) {
            loadedNodes.unshift({
              id: "start",
              type: "startNode",
              position: { x: 250, y: 50 },
              data: {}
            });
          }

          viewportRef.current = flow.viewport || null;
          viewportAplicadoRef.current = false;
          setNodes(loadedNodes);
          setEdges(flow.edges || []);

          const highestId = loadedNodes.reduce((max, node) => {
             const num = parseInt(node.id.replace('node_', ''));
             return isNaN(num) ? max : (num > max ? num : max);
          }, 0);
          idCounter = highestId + 1;
        }
      }
      
      if (!data.flowData || data.flowData === "{}" || Object.keys(JSON.parse(data.flowData)).length === 0) {
        
        setNodes([{
          id: "start",
          type: "startNode",
          position: { x: 250, y: 50 },
          data: {}
        }]);
      }

    } catch (err) {
      toast.error("Erro ao carregar chatbot");
    }
  };

  const onConnectStart = useCallback((event, params) => {
    
    connectingRef.current = params ? { nodeId: params.nodeId, handleId: params.handleId } : null;
    connectionMadeRef.current = false;
  }, []);

  
  const onConnectStop = useCallback((event) => {
    const made = connectionMadeRef.current;
    const src = connectingRef.current;
    connectionMadeRef.current = false;
    connectingRef.current = null;

    if (!made && src && src.nodeId) {
      
      if (
        edges.some(
          (e) =>
            e.source === src.nodeId &&
            (e.sourceHandle || null) === (src.handleId || null)
        )
      ) {
        toast.warn("Essa saída já está ligada a um passo.");
        return;
      }

      setHandleMenu({
        open: true,
        anchorEl: null,
        anchorPosition: { top: event.clientY, left: event.clientX },
        sourceNodeId: src.nodeId,
        sourceHandleId: src.handleId || null,
      });
    }
  }, [edges]);

  const onConnect = useCallback((params) => {
    
    connectionMadeRef.current = true;

    const sourceUsed = edges.some(
      (e) =>
        e.source === params.source &&
        (e.sourceHandle || null) === (params.sourceHandle || null)
    );
    const targetUsed = edges.some((e) => e.target === params.target);
    if (sourceUsed) {
      toast.warn("Essa saída já está ligada a um passo.");
      return;
    }
    if (targetUsed) {
      toast.warn("Esse bloco já tem uma entrada conectada.");
      return;
    }
    pushToUndoStack();
    setEdges((eds) => addEdge(params, eds));
    triggerAutoSave();
  }, [setEdges, reactFlowInstance, edges]);

  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.effectAllowed = "move";
  };

  const onDrop = useCallback(
    (event) => {
      event.preventDefault();

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const type = event.dataTransfer.getData("application/reactflow");

      if (typeof type === "undefined" || !type) {
        return;
      }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });

      const newNode = {
        id: getId(),
        type,
        position,
        data: { text: "", options: [] },
      };

      pushToUndoStack();
      setNodes((nds) => nds.concat(newNode));
      triggerAutoSave();
    },
    [reactFlowInstance, setNodes]
  );

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }, []);

  const onElementsRemove = useCallback(
    (elementsToRemove) => {
      pushToUndoStack();
      
      const nodesToRemove = elementsToRemove.filter(
        e => !e.source && e.type !== "startNode"
      );
      const edgesToRemove = elementsToRemove.filter(e => e.source);
      const idsRemovidos = new Set(nodesToRemove.map(n => n.id));

      setNodes((nds) => nds.filter(n => !idsRemovidos.has(n.id)));

      

      
      
      setEdges((eds) =>
        eds.filter(
          e =>
            !edgesToRemove.find(r => r.id === e.id) &&
            !idsRemovidos.has(e.source) &&
            !idsRemovidos.has(e.target)
        )
      );
      triggerAutoSave();
    },
    [reactFlowInstance]
  );

  
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== "Delete") return;
      const el = document.activeElement;
      const tag = el && el.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || (el && el.isContentEditable)) return;
      const sel = selectedElementsRef.current;
      if (sel && sel.length > 0) {
        e.preventDefault();
        onElementsRemove(sel);
        selectedElementsRef.current = [];
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onElementsRemove]);

  const onNodeClick = (event, node) => {
    // linhas (edges) e o "Inicio do Bot" nao tem o que configurar
    if (!node || node.source || !BLOCOS[node.type] || node.type === "startNode") return;
    setSelectedNode(node);
  };

  const onPaneClick = () => {
    setSelectedNode(null);
  };

  const [enviandoImagem, setEnviandoImagem] = useState(false);
  // arquivo aberto no editor (cortar / girar / zoom) antes de ir para o bloco
  const [arquivoNoEditor, setArquivoNoEditor] = useState(null);
  const [medidaImagem, setMedidaImagem] = useState(null);

  const abrirNoEditor = (arquivo) => {
    if (!arquivo) return;
    if (!/^image\/(jpe?g|png|webp|gif)$/i.test(arquivo.type)) {
      toast.error("Escolha uma imagem JPG, PNG, WEBP ou GIF.");
      return;
    }
    if (arquivo.size > 20 * 1024 * 1024) {
      toast.error("Imagem muito grande (máximo 20 MB).");
      return;
    }
    setArquivoNoEditor(arquivo);
  };

  // reabre a imagem que ja esta no bloco para ajustar de novo
  const ajustarImagemAtual = async () => {
    const url = selectedNode?.data?.imagemUrl;
    if (!url) return;
    try {
      const resp = await fetch(url);
      if (!resp.ok) throw new Error(String(resp.status));
      const blob = await resp.blob();
      const nome = String(selectedNode.data.imagem || "imagem.jpg");
      setArquivoNoEditor(new File([blob], nome, { type: blob.type || "image/jpeg" }));
    } catch (e) {
      toast.error("Não consegui abrir a imagem atual. Use “Trocar imagem” e escolha o arquivo de novo.");
    }
  };
  const enviarImagemDoBloco = async (arquivo) => {
    if (!arquivo) return;
    if (!/^image\/(jpe?g|png|webp|gif)$/i.test(arquivo.type)) {
      toast.error("Escolha uma imagem JPG, PNG, WEBP ou GIF.");
      return;
    }
    if (arquivo.size > 5 * 1024 * 1024) {
      toast.error("Imagem muito grande (máximo 5 MB).");
      return;
    }
    setEnviandoImagem(true);
    try {
      const fd = new FormData();
      fd.append("imagem", arquivo);
      const { data } = await api.post("/chatbots/midia", fd);
      handleSaveNodeData({ imagem: data.filename, imagemUrl: data.url });
    } catch (err) {
      toast.error("Não foi possível enviar a imagem.");
    } finally {
      setEnviandoImagem(false);
    }
  };

  const handleSaveNodeData = (newData) => {
    setNodes((nds) =>
      nds.map((n) => {
        if (n.id === selectedNode.id) {
          n.data = { ...n.data, ...newData };
        }
        return n;
      })
    );
    setSelectedNode({ ...selectedNode, data: { ...selectedNode.data, ...newData } });
    triggerAutoSave();
  };

  const handleSaveFlow = async (silent = false) => {
    if (!reactFlowInstance) {
      setSaveStatus("idle");
      return;
    }
    
    try {
      const flowObject = reactFlowInstance.toObject();
      const elements = flowObject.elements || [];
      const currentNodes = elements.filter(e => !e.source);
      const currentEdges = elements.filter(e => e.source);
      
      const transform = flowObject.position
        ? { x: flowObject.position[0], y: flowObject.position[1], zoom: flowObject.zoom }
        : viewportRef.current;
      if (transform) viewportRef.current = transform;
      salvarPendenteRef.current = false;
      const flowToSave = {
        nodes: currentNodes,
        edges: currentEdges,
        ...(transform ? { viewport: transform } : {})
      };

      await api.put(`/chatbots/${id}`, {
        flowData: JSON.stringify(flowToSave)
      });
      
      if (!silent) toast.success("Fluxo salvo com sucesso!");
      setSaveStatus("saved");
      setTimeout(() => setSaveStatus("idle"), 2000);
    } catch (err) {
      console.error(err);
      if (!silent) toast.error("Erro ao salvar fluxo");
      setSaveStatus("idle");
    }
  };

  return (
    <div className={classes.root}>
      {}
      <div className={classes.topBar}>
        <FormControl variant="outlined" size="small" className={classes.campoTopo} style={{ minWidth: 190, flexShrink: 0 }}>
          <InputLabel>Fluxo Atual</InputLabel>
          <Select
            MenuProps={{ getContentAnchorEl: null, transitionDuration: 0, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" } }}
            value={id || ""}
            onChange={handleChatbotChange}
            label="Fluxo Atual"
          >
            {chatbots.map(c => (
              <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <SeletorConexoes
          chatbotId={id}
          chatbots={chatbots}
          whatsapps={whatsapps}
          onAtualizado={atualizarConexaoLocal}
          className={classes.campoTopo}
        />

        <div className={classes.divisorTopo} />

        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <Tooltip title="Desfazer (Ctrl+Z)">
            <span>
              <IconButton 
                size="small" 
                onClick={handleUndo} 
                disabled={undoStackRef.current.length === 0}
              >
                <UndoIcon />
              </IconButton>
            </span>
          </Tooltip>
          
          <Tooltip title="Refazer (Ctrl+Y)">
            <span>
              <IconButton 
                size="small" 
                onClick={handleRedo}
                disabled={redoStackRef.current.length === 0}
              >
                <RedoIcon />
              </IconButton>
            </span>
          </Tooltip>

          <div style={{ marginLeft: 8, fontSize: "0.82rem", color: "#666", display: "flex", alignItems: "center", minWidth: 78 }}>
            {saveStatus === "saving" && <span style={{ animation: "pulse 1.5s infinite" }}>Salvando...</span>}
            {saveStatus === "saved" && <span style={{ color: "#4caf50", display: "flex", alignItems: "center", gap: 4 }}><CheckCircleIcon fontSize="small" /> Salvo</span>}
          </div>
        </div>

        <div style={{ flexGrow: 1 }} />
        
        {/* Dois botões verdes cheios competiam entre si. "Testar" é a ação do
            dia a dia; "Novo Fluxo" é rara, então vira secundária. */}
        <Button
          variant="outlined"
          color="primary"
          size="small"
          className={classes.botaoTopo}
          startIcon={<AddIcon />}
          onClick={() => setNewChatbotModalOpen(true)}
        >
          Novo Fluxo
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.botaoTopo}
          startIcon={<PlayArrowIcon />}
          onClick={handleTestWithValidation}
        >
          Testar Fluxo
        </Button>
      </div>

      {}
      <Drawer anchor="right" open={simulatorOpen} onClose={() => setSimulatorOpen(false)}>
        <div className={classes.simulatorDrawer}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">Simulador</Typography>
            <IconButton size="small" onClick={() => setSimulatorOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <div className={classes.chatMessageContainer}>
            {chatHistory.map((msg, index) => (
              <div key={index} className={
                msg.type === "bot" ? classes.chatBubbleBot :
                msg.type === "user" ? classes.chatBubbleUser :
                classes.chatBubbleSystem
              }>
                {msg.text}
                {msg.options && msg.options.length > 0 && (
                  <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 5 }}>
                    {msg.options.map((opt, i) => (
                      <Button
                        key={i}
                        variant="outlined"
                        size="small"
                        color="primary"
                        style={{ textTransform: "none", justifyContent: "flex-start", textAlign: "left" }}
                        onClick={() => handleSimulatorOptionClick(msg.nodeId, i, opt)}
                      >
                        {opt}
                      </Button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 4, padding: "10px 0", borderTop: `1px solid ${theme.palette.divider}`, marginTop: 10 }}>
            <TextField
              variant="outlined"
              size="small"
              placeholder="Digite uma mensagem..."
              fullWidth
              value={simulatorInputText}
              onChange={(e) => setSimulatorInputText(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleSimulatorTextSend()}
              InputProps={{
                style: {
                  backgroundColor: theme.palette.type === "dark" ? "#202c33" : "#fff",
                  color: theme.palette.text.primary,
                  borderRadius: 8,
                },
              }}
            />
            <IconButton color="primary" onClick={handleSimulatorTextSend}>
              <SendIcon />
            </IconButton>
          </div>
        </div>
      </Drawer>

      <div className={classes.content}>
        {!blocksOpen && (
          <div className={classes.blocksCollapsed}>
            <IconButton size="small" onClick={() => setBlocksOpen(true)} title="Mostrar blocos">
              <ChevronRightIcon />
            </IconButton>
          </div>
        )}
        <Paper className={classes.sidebar} square style={{ display: blocksOpen ? undefined : "none" }}>
          <div className={classes.paletaTopo}>
            <div>
              <div className={classes.paletaTitulo}>Blocos</div>
              <div className={classes.paletaSub}>Arraste para o quadro</div>
            </div>
            <IconButton size="small" onClick={() => setBlocksOpen(false)} title="Recolher">
              <ChevronLeftIcon />
            </IconButton>
          </div>

          {ORDEM_PALETA.map((tipo, i) => {
            const meta = BLOCOS[tipo];
            const Icone = meta.Icone;
            return (
              <div
                key={tipo}
                className={classes.nodeItem}
                style={{ "--cor": meta.cor, "--cor-suave": hexRgba(meta.cor, 0.14), animationDelay: `${i * 0.05}s` }}
                onDragStart={(e) => onDragStart(e, tipo)}
                draggable
                title="Arraste para o quadro"
              >
                <span className={classes.nodeItemIcone}><Icone style={{ fontSize: 19 }} /></span>
                <span style={{ minWidth: 0, flex: 1 }}>
                  <span className={classes.nodeItemNome}>{meta.curto || meta.nome}</span>
                  <span className={classes.nodeItemDesc}>{meta.desc}</span>
                </span>
                <DragIndicatorRoundedIcon className={classes.nodeItemArrastar} />
              </div>
            );
          })}

          <div className={classes.dica}>
            <TouchAppRoundedIcon style={{ fontSize: 18, color: "#14b8a6", flexShrink: 0 }} />
            <span>Clique num bloco do quadro para editar. Puxe a bolinha verde de um bloco para ligar ao próximo passo.</span>
          </div>

          <div style={{ flexGrow: 1 }} />
          <Button variant="contained" color="primary" onClick={() => handleSaveFlow()} className={classes.botaoSalvar}>
            Salvar Fluxo
          </Button>
        </Paper>

        {/* Edicao do bloco em modal */}
        <Dialog
          open={!!selectedNode && !!BLOCOS[selectedNode.type] && selectedNode.type !== "startNode"}
          onClose={() => setSelectedNode(null)}
          maxWidth="sm"
          fullWidth
          PaperProps={{ className: classes.modalBloco }}
        >
          {selectedNode && BLOCOS[selectedNode.type] && (() => {
            const meta = BLOCOS[selectedNode.type];
            const Icone = meta.Icone;
            return (
              <div
                className={classes.modalCabecalho}
                style={{ background: `linear-gradient(135deg, ${meta.cor}, ${hexRgba(meta.cor, 0.75)})` }}
              >
                <span className={classes.modalIcone}><Icone /></span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className={classes.modalTitulo}>{meta.nome}</div>
                  <div className={classes.modalSub}>{meta.desc}</div>
                </div>
                <IconButton size="small" onClick={() => setSelectedNode(null)} style={{ color: "#fff" }}>
                  <CloseIcon />
                </IconButton>
              </div>
            );
          })()}
          <DialogContent className={classes.modalCorpo}>
        {selectedNode && selectedNode.type === "textNode" && (
          <div>
            <Typography variant="subtitle2">Configurar Mensagem</Typography>
            {/* imagem opcional: sai junto, com o texto como legenda */}
            {selectedNode.data.imagemUrl ? (
              <div className={classes.imgBloco}>
                <img
                  src={selectedNode.data.imagemUrl}
                  alt="Imagem do bloco"
                  className={classes.imgPrevia}
                  onLoad={(e) => setMedidaImagem({ l: e.target.naturalWidth, a: e.target.naturalHeight })}
                />
                <div className={classes.imgAcoes}>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    disableElevation
                    startIcon={<TuneRoundedIcon />}
                    onClick={ajustarImagemAtual}
                    disabled={enviandoImagem}
                  >
                    Ajustar imagem
                  </Button>
                  <Button size="small" variant="outlined" component="label" disabled={enviandoImagem}>
                    {enviandoImagem ? "Enviando…" : "Trocar imagem"}
                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/webp,image/gif"
                      hidden
                      onChange={(e) => {
                        abrirNoEditor(e.target.files && e.target.files[0]);
                        e.target.value = "";
                      }}
                    />
                  </Button>
                  <Button
                    size="small"
                    style={{ color: "#dc2626" }}
                    onClick={() => {
                      handleSaveNodeData({ imagem: "", imagemUrl: "" });
                      setMedidaImagem(null);
                    }}
                  >
                    Remover
                  </Button>
                  {medidaImagem && (
                    <span className={classes.imgMedida}>
                      {medidaImagem.l} × {medidaImagem.a} px
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <Button
                component="label"
                variant="outlined"
                fullWidth
                disabled={enviandoImagem}
                startIcon={<AddPhotoAlternateOutlinedIcon />}
                className={classes.imgAdicionar}
              >
                {enviandoImagem ? "Enviando imagem…" : "Adicionar imagem (opcional)"}
                <input
                  type="file"
                  accept="image/jpeg,image/png,image/webp,image/gif"
                  hidden
                  onChange={(e) => {
                    abrirNoEditor(e.target.files && e.target.files[0]);
                    e.target.value = "";
                  }}
                />
              </Button>
            )}
            <TextField
              label={selectedNode.data.imagemUrl ? "Legenda da imagem" : "Texto"}
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              value={selectedNode.data.text || ""}
              onChange={(e) => handleSaveNodeData({ text: e.target.value })}
              helperText="Use {{name}} para o nome do candidato."
              style={{ marginTop: 10, marginBottom: 10 }}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={!!selectedNode.data.waitForReply}
                  onChange={(e) => handleSaveNodeData({ waitForReply: e.target.checked })}
                  color="primary"
                />
              }
              label="Aguardar resposta do candidato?"
            />

            {(selectedNode.data.imagemUrl || selectedNode.data.text) && (
              <div className={classes.zapCaixa}>
                <div className={classes.zapTopo}>Prévia no WhatsApp do candidato</div>
                <div className={classes.zapFundo}>
                  <div className={classes.zapBalao}>
                    {selectedNode.data.imagemUrl && (
                      <img src={selectedNode.data.imagemUrl} alt="" className={classes.zapImagem} />
                    )}
                    {selectedNode.data.text && (
                      <div
                        className={classes.zapTexto}
                        dangerouslySetInnerHTML={{
                          __html: String(selectedNode.data.text)
                            .replace(/&/g, "&amp;")
                            .replace(/</g, "&lt;")
                            .replace(/>/g, "&gt;")
                            .replace(/\{\{\s*name\s*\}\}/gi, "Marina")
                            .replace(/\*([^*\n]+)\*/g, "<b>$1</b>")
                            .replace(/_([^_\n]+)_/g, "<i>$1</i>"),
                        }}
                      />
                    )}
                    <span className={classes.zapHora}>
                      {new Date().toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })} ✓✓
                    </span>
                  </div>
                </div>
                {medidaImagem && medidaImagem.a / medidaImagem.l > 1.6 && (
                  <div className={classes.zapAviso}>
                    Imagem bem comprida: na conversa o WhatsApp pode mostrar só uma parte até o candidato tocar nela.
                    Em <b>Ajustar imagem</b>, use o formato <b>Retrato</b> ou <b>Quadrado</b> para ela aparecer inteira.
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {selectedNode && selectedNode.type === "menuNode" && (
          <div>
            <Typography variant="subtitle2">Configurar Menu</Typography>
             <TextField
              label="Texto de introdução"
              multiline
              rows={2}
              variant="outlined"
              size="small"
              fullWidth
              value={selectedNode.data.text || ""}
              onChange={(e) => handleSaveNodeData({ text: e.target.value })}
              style={{ marginTop: 8, marginBottom: 8 }}
            />
            <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 8, marginBottom: 6, fontWeight: 600 }}>
              Opções (número e texto)
            </Typography>
            {(selectedNode.data.options || []).map((opt, i) => {
              const dashIdx = opt.indexOf("-");
              const num = dashIdx === -1 ? opt.trim() : opt.slice(0, dashIdx).trim();
              const label = dashIdx === -1 ? "" : opt.slice(dashIdx + 1).trim();
              const setOpt = (n, l) => {
                const arr = [...(selectedNode.data.options || [])];
                arr[i] = `${n} - ${l}`;
                handleSaveNodeData({ options: arr });
              };
              return (
                <div key={i} style={{ display: "flex", gap: 4, marginBottom: 6, alignItems: "center", minWidth: 0 }}>
                  <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Nº"
                    value={num}
                    onChange={(e) => setOpt(e.target.value, label)}
                    style={{ width: 44, flexShrink: 0 }}
                  />
                  <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Texto da opção"
                    fullWidth
                    value={label}
                    onChange={(e) => setOpt(num, e.target.value)}
                  />
                  <IconButton
                    size="small"
                    onClick={() => {
                      const arr = [...(selectedNode.data.options || [])];
                      arr.splice(i, 1);

                      

                      

                      
                      const idNo = selectedNode.id;
                      setEdges((eds) =>
                        eds
                          .filter(
                            e =>
                              !(
                                e.source === idNo &&
                                e.sourceHandle === `option_${i}`
                              )
                          )
                          .map((e) => {
                            if (e.source !== idNo || !e.sourceHandle) return e;
                            const pos = parseInt(
                              String(e.sourceHandle).replace("option_", ""),
                              10
                            );
                            if (!Number.isFinite(pos) || pos < i) return e;
                            return { ...e, sourceHandle: `option_${pos - 1}` };
                          })
                      );

                      handleSaveNodeData({ options: arr });
                    }}
                  >
                    <CloseIcon fontSize="small" style={{ color: "#e5484d" }} />
                  </IconButton>
                </div>
              );
            })}
            <Button
              size="small"
              startIcon={<AddIcon />}
              onClick={() => {
                const arr = [...(selectedNode.data.options || [])];
                arr.push(`${arr.length + 1} - `);
                handleSaveNodeData({ options: arr });
              }}
              style={{ textTransform: "none", marginTop: 2 }}
            >
              Adicionar opção
            </Button>
            <FormControlLabel
              style={{ marginTop: 10 }}
              control={
                <Switch
                  size="small"
                  color="primary"
                  checked={selectedNode.data.showReplyHint !== false}
                  onChange={(e) => {

                    if (e.target.checked && selectedNode.data.replyHintText === undefined) {
                      handleSaveNodeData({
                        showReplyHint: true,
                        replyHintText: "Responda com o número da opção."
                      });
                    } else {
                      handleSaveNodeData({ showReplyHint: e.target.checked });
                    }
                  }}
                />
              }
              label={
                <Typography variant="caption">
                  Adicionar instrução no final da mensagem
                </Typography>
              }
            />
            {selectedNode.data.showReplyHint !== false && (
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                label="Texto da instrução"
                placeholder="Nenhuma instrução será enviada"
                value={selectedNode.data.replyHintText ?? "Responda com o número da opção."}
                onChange={(e) => handleSaveNodeData({ replyHintText: e.target.value })}
                style={{ marginTop: 6 }}
                helperText="Vazio = nenhuma instrução é enviada."
              />
            )}
            <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 10 }}>
              * Ligue as opções (pontinhos à direita do nó) aos próximos passos.
            </Typography>
          </div>
        )}

        {selectedNode && selectedNode.type === "queueNode" && (
          <div>
            <Typography variant="subtitle2">Transferir para Usuário</Typography>
            <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 4, marginBottom: 10 }}>
              O cliente vai direto para este atendente e recebe a saudação dele
              na hora.
            </Typography>
            <FormControl variant="outlined" fullWidth style={{ marginTop: 10 }}>
              <InputLabel>Selecione o atendente</InputLabel>
              <Select
                MenuProps={{ getContentAnchorEl: null, transitionDuration: 0, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" } }}
                value={selectedNode.data.userId || ""}
                onChange={(e) => {
                  const u = atendentes.find(u => u.id === e.target.value);
                  handleSaveNodeData({ userId: e.target.value, userName: u ? u.name : "" })
                }}
                label="Selecione o atendente"
              >
                <MenuItem value={""}>Nenhum</MenuItem>
                {atendentes.map(u => (
                  <MenuItem key={u.id} value={u.id}>{u.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}

        {selectedNode && selectedNode.type === "humanNode" && (
          <div>
            <Typography variant="subtitle2">Enviar para humano</Typography>
            <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 4, marginBottom: 10 }}>
              O fluxo termina aqui e o cliente fica aguardando atendimento.
              A IA não é acionada.
            </Typography>

            <TextField
              select
              label="Atendente (opcional)"
              variant="outlined"
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              SelectProps={{ native: true }}
              value={selectedNode.data.userId || ""}
              onChange={(e) => {
                const valor = e.target.value;
                const u = atendentes.find(u => String(u.id) === String(valor));
                handleSaveNodeData({ userId: valor, userName: u ? u.name : "" });
              }}
              helperText="Em branco, o candidato entra na espera geral e qualquer atendente pode assumir."
            >
              <option value="">Qualquer atendente</option>
              {atendentes.map(u => (
                <option key={u.id} value={u.id}>{u.name}</option>
              ))}
            </TextField>
          </div>
        )}

        {selectedNode && selectedNode.type === "locationNode" && (
          <div>
            <Typography variant="subtitle2">Localização da empresa</Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
              Manda o pino com o mini mapa no WhatsApp e, logo depois, o endereço com o link do Google Maps.
              O endereço é o cadastrado em <b>Assistente IA → Comportamento → Localização da empresa</b>.
            </Typography>
          </div>
        )}

        {selectedNode && selectedNode.type === "delayNode" && (
          <div>
            <Typography variant="subtitle2">Pausa (Tempo de espera)</Typography>
             <TextField
              label="Segundos"
              type="number"
              variant="outlined"
              fullWidth
              value={selectedNode.data.delay || 0}
              onChange={(e) => handleSaveNodeData({ delay: parseInt(e.target.value) || 0 })}
              style={{ marginTop: 10 }}
            />
          </div>
        )}

        {selectedNode && selectedNode.type === "aiNode" && (
          <div>
            <Typography variant="subtitle2">Enviar para IA</Typography>
            <Typography variant="caption" color="textSecondary" style={{ display: "block", marginTop: 4, marginBottom: 10 }}>
              A assistente assume o atendimento a partir daqui.
            </Typography>

            <TextField
              label="Instrução para esta etapa"
              variant="outlined"
              size="small"
              fullWidth
              multiline
              minRows={4}
              maxRows={10}
              InputLabelProps={{ shrink: true }}
              placeholder={
                "Ex.: O candidato escolheu a vaga de Atendente de Loja.\n" +
                "Não repita a saudação. Pergunte se ele tem experiência com\n" +
                "atendimento e siga para o agendamento da entrevista."
              }
              value={selectedNode.data.instrucao || ""}
              onChange={(e) => handleSaveNodeData({ instrucao: e.target.value })}
              helperText="Some-se ao prompt principal, só neste caminho do fluxo. Deixe vazio para a assistente seguir apenas o prompt geral."
            />
          </div>
        )}

          </DialogContent>
          <DialogActions className={classes.modalRodape}>
            <Button
              startIcon={<DeleteOutlineRoundedIcon />}
              onClick={() => {
                if (!selectedNode) return;
                onElementsRemove([selectedNode]);
                setSelectedNode(null);
              }}
              style={{ color: "#e5484d", textTransform: "none", fontWeight: 600 }}
            >
              Excluir
            </Button>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<FileCopyIcon />}
              onClick={() => { handleDuplicateNode(); setSelectedNode(null); }}
              style={{ textTransform: "none", fontWeight: 600, borderRadius: 10 }}
            >
              Duplicar
            </Button>
            <div style={{ flex: 1 }} />
            <Button
              variant="contained"
              color="primary"
              onClick={() => setSelectedNode(null)}
              style={{ textTransform: "none", fontWeight: 700, borderRadius: 10, padding: "7px 22px" }}
            >
              Concluir
            </Button>
          </DialogActions>
        </Dialog>

      <div className={classes.flowWrapper} ref={reactFlowWrapper}>
        <HandleMenuContext.Provider value={openHandleMenu}>
          <ReactFlow
            elements={[...nodes, ...edges]}
            onConnect={onConnect}
            onConnectStart={onConnectStart}
            onConnectStop={onConnectStop}
            onLoad={setReactFlowInstance}
            onDrop={onDrop}
            onDragOver={onDragOver}
            onElementsRemove={onElementsRemove}
            onNodeDragStart={() => pushToUndoStack()}
            onNodeDragStop={aoTerminarDeArrastar}
            onSelectionDragStop={aoTerminarDeArrastar}
            onMoveEnd={(tr) => {
              if (tr && Number.isFinite(tr.zoom)) viewportRef.current = { x: tr.x, y: tr.y, zoom: tr.zoom };
            }}
            onSelectionChange={(els) => { selectedElementsRef.current = els || []; }}
            onElementClick={onNodeClick}
            onPaneClick={onPaneClick}
            nodeTypes={nodeTypes}
            minZoom={0.15}
            maxZoom={2}
            zoomOnDoubleClick={false}
            selectNodesOnDrag={false}
          >
            <Background color={theme.palette.type === 'dark' ? "#555" : "#aaa"} gap={16} />
            <Controls style={{ filter: theme.palette.type === 'dark' ? 'invert(100%)' : 'none' }} />
            <MiniMap 
              nodeColor={(n) => theme.palette.type === "dark" ? "#fff" : "#e2e2e2"}
              maskColor={theme.palette.type === "dark" ? "rgba(0, 0, 0, 0.6)" : "rgba(240, 240, 240, 0.6)"}
              style={{ backgroundColor: theme.palette.background.paper }}
            />
          </ReactFlow>
        </HandleMenuContext.Provider>
        
        <Menu
          anchorReference={handleMenu.anchorPosition ? "anchorPosition" : "anchorEl"}
          anchorEl={handleMenu.anchorEl}
          anchorPosition={handleMenu.anchorPosition || undefined}
          keepMounted
          open={handleMenu.open}
          onClose={closeHandleMenu}
        >
          <MenuItem onClick={() => handleAddNodeFromMenu('textNode')}>Mensagem de Texto</MenuItem>
          <MenuItem onClick={() => handleAddNodeFromMenu('menuNode')}>Menu de Opções</MenuItem>
          <MenuItem onClick={() => handleAddNodeFromMenu('queueNode')}>Transferir para Usuário</MenuItem>
          <MenuItem onClick={() => handleAddNodeFromMenu('locationNode')}>Localização</MenuItem>
          <MenuItem onClick={() => handleAddNodeFromMenu('delayNode')}>Tempo de Espera</MenuItem>
          <MenuItem onClick={() => handleAddNodeFromMenu('aiNode')}>Enviar para IA</MenuItem>
          <MenuItem onClick={() => handleAddNodeFromMenu('humanNode')}>Enviar para humano</MenuItem>
        </Menu>

        <Dialog open={newChatbotModalOpen} onClose={() => setNewChatbotModalOpen(false)}>
          <DialogTitle>Criar Novo Fluxo</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Nome do Fluxo"
              fullWidth
              variant="outlined"
              value={newChatbotName}
              onChange={(e) => setNewChatbotName(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setNewChatbotModalOpen(false)} color="default">
              Cancelar
            </Button>
            <Button onClick={handleCreateChatbot} color="primary" variant="contained">
              Criar
            </Button>
          </DialogActions>
        </Dialog>

        {}
        <Dialog open={validationDialogOpen} onClose={() => setValidationDialogOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle style={{ display: "flex", alignItems: "center", gap: 10, color: "#f57c00" }}>
            <WarningIcon />
            Atenção: Problemas encontrados no fluxo
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" style={{ marginBottom: 15 }}>
              Foram encontrados alguns problemas que podem fazer o chatbot não funcionar corretamente:
            </Typography>
            <ul style={{ paddingLeft: 20, margin: 0, color: "#d32f2f" }}>
              {validationErrors.map((err, idx) => (
                <li key={idx} style={{ marginBottom: 5 }}>
                  <strong>{err.type === "error" ? "Erro" : "Aviso"}:</strong> {err.text}
                </li>
              ))}
            </ul>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setValidationDialogOpen(false)} color="default">
              Voltar e Corrigir
            </Button>
            <Button 
              onClick={() => {
                setValidationDialogOpen(false);
                startSimulator();
              }} 
              color="primary" 
              variant="contained"
            >
              Testar Mesmo Assim
            </Button>
          </DialogActions>
        </Dialog>

        {}
        <style>{`
          @keyframes pulse {
            0% { opacity: 1; }
            50% { opacity: 0.5; }
            100% { opacity: 1; }
          }
        `}</style>
      </div>
      </div>
      <EditorDeImagem
        open={!!arquivoNoEditor}
        arquivo={arquivoNoEditor}
        onCancel={() => setArquivoNoEditor(null)}
        onConfirmar={(arquivo) => {
          setArquivoNoEditor(null);
          setMedidaImagem(null);
          enviarImagemDoBloco(arquivo);
        }}
      />
    </div>
  );
};

export default ChatbotBuilder;
